import { render, staticRenderFns } from "./GymVideo.vue?vue&type=template&id=76f70156&scoped=true&"
import script from "./GymVideo.vue?vue&type=script&lang=js&"
export * from "./GymVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f70156",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76f70156')) {
      api.createRecord('76f70156', component.options)
    } else {
      api.reload('76f70156', component.options)
    }
    module.hot.accept("./GymVideo.vue?vue&type=template&id=76f70156&scoped=true&", function () {
      api.rerender('76f70156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Gym/GymVideo.vue"
export default component.exports